import { render, staticRenderFns } from "./Form4473Detail.vue?vue&type=template&id=3b571a74&scoped=true"
import script from "./Form4473Detail.vue?vue&type=script&lang=js"
export * from "./Form4473Detail.vue?vue&type=script&lang=js"
import style0 from "./Form4473Detail.vue?vue&type=style&index=0&id=3b571a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b571a74",
  null
  
)

export default component.exports